export default __webpack_public_path__ + "static/media/carousel-isp-mdu-05.f1b56b9a.png";